import {AfterViewInit, Component, OnInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {CurrencyModel} from '../../../../DataModels/currency-model';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {Observable} from 'rxjs';
import {AccountModel} from '../../../../DataModels/account-model';
import { BsToastService} from '../../../../Services/bs-toast-service';
import {Title} from '@angular/platform-browser';
import {NavigationService} from '../../../../Services/navigation.service';

@Component({
  selector: 'app-currency-form',
  templateUrl: './currency-form.component.html',
  styleUrls: ['./currency-form.component.css'],
  standalone: false
})
export class CurrencyFormComponent implements OnInit, AfterViewInit {
  buttonConfig: any = {
    save: true,
    close: true,
    reset: true,
    delete: true,
    saveNew: true,
    saveClose: true,
    print: false,
  };
  accounts$: Observable<AccountModel[]>;
  accounts = [];

  currencyID: string;

  currency: CurrencyModel;
  currencyForm: UntypedFormGroup;

  buttonsDisabled = false;

  submitted = false;
  originalSnapshot: any = {};

  constructor(private table: DataService,
              private notification: BsToastService,
              private formBuilder: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private confirmDialogService: ConfirmDialogService,
              private titleService: Title,
              private nav: NavigationService) {
    this.createForm();
    this.currencyID = this.route.snapshot.params.id;
  }

  get f() {
    return this.currencyForm.controls;
  }

  createForm() {
    this.currencyForm = this.formBuilder.group({
      code: new UntypedFormControl(''),
      name: new UntypedFormControl(''),
      account_id: new UntypedFormControl(''),
      active: new UntypedFormControl('true'),
    });
  }
  ngOnInit() {
    if (this.currencyID) {
      this.LoadData();
      this.loadAccount();
      this.buttonConfig.reset = false;
    } else {
      this.loadAccount();
      Promise.resolve().then(() => {
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      });
    }
  }

  ngAfterViewInit() {
    // this.titleService.setTitle($localize`:Currency @@currency:Currency` + ' - ' + this.currencyForm.controls.name.value );
  }

  private LoadData() {
    this.table.getData('currency', this.currencyID).subscribe(
      (result: any) => {
        // Many endpoints return a wrapper { Data: T }. Some may return raw T.
        const data = (result && result.Data !== undefined) ? result.Data : result;
        this.currency = data as CurrencyModel;
        // console.log('currency: ' , this.currency);
        // Patch the form/title once we have the data to avoid patching null
        this.currencyForm.patchValue(this.currency);
        this.titleService.setTitle($localize`:Currency @@currency:Currency` + ' - ' + this.currencyForm.controls.code.value);
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
      },
      (error: HttpErrorResponse) => {
        // this.notification.error($localize`:Error loading Currencies @@errorLoadingCurrencies:Error loading Currencies`);
        console.log(error);
      }
    );
  }

  saveClose() {
    if (this.onSave(true, false)) {
    }
  }

  saveNew() {
    // Defer reset until async save completes inside onSave(false)
    this.onSave(false, true);
  }

  deleteItem() {
    let retMsg = '';
    const messages: string[] = [$localize`:Are you sure you want to delete currency? @@areYouSureWouWantToDeleteCurrency:Are you sure you want to delete currency?`, this.currency.name];
    this.confirmDialogService.confirmThis(messages,
      () => {
        this.table.deleteDataById('currency', this.currencyID).subscribe(
          result => {
            retMsg = result;
            // this.notification.success($localize`:Deleted @@deleted:Deleted`);
          },
          (error: HttpErrorResponse) => {
            // this.notification.error($localize`:Error @@error:Error`);
            console.log(error);
          },
          () => {
            this.onClose();
          });
      }, () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      });
  }

  resetForm() {
    this.currencyForm.reset();
    try {
      this.originalSnapshot = this.buildSnapshot();
    } catch {
    }
  }

  onClose() {
    const fallback = '/admin/currency-list';
    this.nav.backOr(fallback);
  }

  onSave(saveClose: boolean = false, saveNew: boolean = false) {
    this.submitted = true;
    if (this.currencyForm.invalid) {
      this.notification.showWarningToast('Form Errors');
      return;
    }
    this.currency = Object.assign({}, this.currencyForm.value);
    if (this.currencyID) {
        this.table.patch('currency', this.currencyID, this.currency).then(result => {
            try {
              this.originalSnapshot = this.buildSnapshot();
            } catch {
            }
            if (saveClose){
              this.onClose();
            } else if (saveNew) {
              this.currencyForm.reset();
            }
          },
          (error: HttpErrorResponse) => {
            //
            console.log(error);
          });
        // return true;
    } else {
      // console.log('currency: ', this.currency);
      this.table.post('currency', this.currency).subscribe((res: any) => {
        // console.log('res: ', res);

        this.currencyID = res.id;
        try {
          this.originalSnapshot = this.buildSnapshot();
        } catch {
        }
        if (saveClose){
          this.onClose();
        } else {
          this.currencyForm.reset();
        }
      });

      //  this.notification.success($localize`:Saved @@saved:Saved`);
      // return true;
    }
    this.submitted = false;
    return true;
  }

  buildSnapshot(): any {
    try {
      return this.currencyForm.getRawValue();
    } catch {
      return {};
    }
  }

  hasChanges(): boolean {
    try {
      const current = this.buildSnapshot();
      const original = this.originalSnapshot || {};
      return JSON.stringify(current) !== JSON.stringify(original);
    } catch {
      return false;
    }
  }

  checkForChanges(): boolean {
    return this.hasChanges();
  }

  loadAccount() {
    this.table.getData('account', '?pageNumber=0&pageSize=999999').subscribe((res: ResponseModel) => {
      const data: any = res.Data;
      this.accounts = data;
      // console.log('accts: ' + JSON.stringify(data));
    });
  }

}
